import { render } from "./Link.vue?vue&type=template&id=a27baa7a&scoped=true"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"

import "./Link.vue?vue&type=style&index=0&id=a27baa7a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a27baa7a"

export default script